import type { Products } from "../types"

export const products: Products = new Map([
  [
    "euler-base",
    {
      name: "Euler Swell",
      description:
        "A market tailored to executing ETH-based carry-trade strategies. Governed by Euler DAO.",
      entity: "euler-dao",
      url: "",
      vaults: [
        "0x49C077B74292aA8F589d39034Bf9C1Ed1825a608",
        "0x3C12AA52b014Acf7957308808362909b5757cca8",
        "0x10D0D11A8B693F4E3e33d09BBab7D4aFc3C03ef3",
        "0x4a5C95a0e3FCA4148F91cEb637fBA0E1080BE40e",
        "0x46e3c018798d6de4517A3c98358E4BD8D334B79C",
        "0xf34253Ec3Dd0cb39C29cF5eeb62161FB350A9d14",
        "0x1773002742A2bCc7666e38454F761CE8fe613DE5",
        "0x29c85c752e854b0Cf2372e6B6c56f260755f5120",
      ],
    },
  ],
  [
    "relend-network",
    {
      name: "Relend Network Swell",
      description:
        "A market to borrow stablecoin on Swell. Governed by Relend Network.",
      entity: "relend-network",
      url: "https://relend.network/",
      vaults: ["0xc5976e0356f0A3Ce8307fF08C88bB05933F88761"],
    },
  ],
])
